module.exports = __webpack_public_path__ + "static/floorplan-82a3808fa9e87e596459d7b3b4538ab2.png";